import { defineStore } from 'pinia';
import { store } from '/@/store';
import type { TabTaskStatus } from '/@/utils/tab_task_badge/tab_task_badge_policy';

interface ILoadingInfo {
  visible: boolean;
  loadingProgress: number;
  loadingWord: string;
  loadingStyle: number;
  hasLoadingProgress: boolean;
  closeable: boolean;
  taskStatus: TabTaskStatus;
}

export const useLoadingStore = defineStore({
  id: 'loading',
  state: (): ILoadingInfo => ({
    visible: false,
    loadingProgress: 0,
    loadingWord: '',
    loadingStyle: 0,
    hasLoadingProgress: true,
    closeable: true,
    taskStatus: 'idle',
  }),
  actions: {
    setVisible(val: boolean) {
      this.visible = val;
      if (val) {
        this.taskStatus = 'executing';
        return;
      }
      if (this.taskStatus === 'executing') {
        this.taskStatus = 'interrupt';
      }
    },
    setLoadingStyle(loadingStyle: number) {
      this.loadingStyle = loadingStyle;
    },
    setLoadingWord(loadingWord: string) {
      this.loadingWord = loadingWord;
    },
    setLoadingProgress(loadingProgress: number) {
      this.loadingProgress = loadingProgress;
    },
    setCloseable(closeable: boolean) {
      this.closeable = closeable;
    },
    succeed() {
      if (this.taskStatus !== 'executing') {
        return;
      }
      this.visible = false;
      this.taskStatus = 'success';
    },
    fail() {
      if (this.taskStatus !== 'executing') {
        return;
      }
      this.visible = false;
      this.taskStatus = 'fail';
    },
    interrupt() {
      if (this.taskStatus !== 'executing') {
        return;
      }
      this.visible = false;
      this.taskStatus = 'interrupt';
    },
    markExecuting() {
      this.taskStatus = 'executing';
    },
    clearTaskStatus() {
      this.taskStatus = 'idle';
    },
    initLoading() {
      this.loadingProgress = 0;
      this.loadingStyle = 0;
      this.loadingWord = '';
      this.hasLoadingProgress = true;
      this.closeable = true;
    },
  },
});

export function useLoadingStoreWithOut() {
  return useLoadingStore(store);
}
